import React from "react";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <section className="relative text-white min-h-screen flex flex-col justify-center bg-cover bg-center sm:pt-44  overflow-visible" style={{ backgroundImage: "url('/images/herosection_1.png')", zIndex: 1 }}>
      <div className="absolute inset-0 bg-black/30 z-0" />
      
      {/* Contenu principal avec boutons */}
      <div className="relative z-20 max-w-5xl mx-auto px-4 flex flex-col items-center text-center">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-medium mb-12 lg:mb-16 leading-tight">
          Un écosystème <span className="text-blue-500">RH à 360°</span>, pensé pour vos besoins d'entreprise.
        </h1>
        <p className="mb-12 md:mb-12 lg:mb-16 text-base md:text-lg text-gray-300 max-w-4xl leading-relaxed">
          Bienvenue sur <span className="font-semibold">Dowonou</span>, votre partenaire incontournable pour une gestion des employés plus efficace et moderne. <span className="font-semibold">Dowonou</span>, une solution complète et intuitive qui centralise toutes les fonctions RH en un seul outil.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 mb-8 sm:mb-12 lg:mb-16 justify-center w-full sm:w-auto">
          <button onClick={() => navigate('/contact')} className="bg-blue-700 hover:bg-blue-800 text-white px-4 sm:px-6 py-2 sm:py-3 rounded transition text-sm sm:text-base">Contactez-nous</button>
          <button onClick={() => navigate('/contact')} className="hover:bg-gray-800/40 text-white px-4 sm:px-6 py-2 sm:py-3 rounded transition border border-white text-sm sm:text-base">Demander de démo</button>
        </div>
      </div>

      {/* Dashboard mockup débordant */}
      <div className="relative z-10 sm:flex justify-center mx-4 pointer-events-none select-none hidden">
        <div className="w-full max-w-5xl">
          <img src="/images/dash_mockup.png" alt="dashboard" className="w-full h-auto object-contain relative -mb-24 md:-mb-32 lg:-mb-40 xl:-mb-96" style={{ zIndex: 10 }} />
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 